import * as t from 'io-ts'
import { form2 } from '@pulseops/common'

export namespace ReportForm {
  export const codec = t.type({
    fromDate: form2.date.required,
    toDate: form2.date.required
  })
}
